import React, { useContext } from 'react';
import { GlobalContext } from '../context/globalContext';
import { GlobalStyle } from '../styles/homeStyles';

import { ThemeProvider } from 'styled-components';

const Theme = ({ children }) => {
  const darkTheme = {
    theme: 'dark',
    background: '#232323',
    secondaryBackground: '#171819',
    subBackground: '#232323',

    text: '#FFFFFF',
    subText: '#AAAAAA',
    colorText: '#2f4693',
    cancelText: '#888a90',
    disabledText: '#555555',
    button: '#4475FE',

    line: '#494b4f',
    subLine: '#707377',
    airLine: '#36373a',
  };

  const lightTheme = {
    theme: 'light',
    background: '#FFFFFF',
    secondaryBackground: '#fafafa',
    subBackground: '#fefefe',

    text: '#232323',
    subText: '#555555',
    colorText: '#203058',
    cancelText: '#888a90',
    disabledText: '#aaaaaa',
    button: '#2f4693',

    line: '#eeeeee',
    subLine: '#cccccc',
    airLine: '#eeeeee',
  };

  const currentTheme = useContext(GlobalContext);
  let theme;
  switch (currentTheme.theme) {
    case 'dark':
      theme = darkTheme;
      break;
    case 'light':
      theme = lightTheme;
      break;
    default:
      theme = lightTheme;
  }

  return (
    <ThemeProvider theme={theme}>
      <meta name='theme-color' content={theme.background} />
      <GlobalStyle />

      {children}
    </ThemeProvider>
  );
};

export default Theme;
